var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"loader-background"},[_c('div',{staticClass:"progress-bar",style:({ height: _vm.height + '%'})},[_c('div',{staticClass:"percentage",class:_vm.percentageClass},[_vm._v(_vm._s(_vm.percentage)+"%")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5945bf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/ProgressLoader.vue
// module id = null
// module chunks = 